<wbo-edit-page #editPage [formGroup]="editPage.formGroup">
    <fui-rows>
        <fui-row>
            <fui-two-columns>
                <fui-column formGroupName="recUser">
                    <wbo-posuser-single-select-edit-control
                        formControlName="userId"
                        [(ngModel)]="model.data.recUser.userId"
                        (onSelect)="employeeSelected($event)"></wbo-posuser-single-select-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-outlet-single-select-edit-control
                        formControlName="outletId"
                        [(ngModel)]="model.data.outletId"></wbo-outlet-single-select-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-date-edit-control
                        formControlName="startDate" [(ngModel)]="model.data.startDate"
                        (valueChange)="shiftStartDateChanged($event)"></wbo-date-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-time-edit-control
                        formControlName="startTime"
                        [(ngModel)]="model.data.startTime"
                        (valueChange)="shiftStartTimeChanged($event)"></wbo-time-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-date-edit-control
                        formControlName="finishDate"
                        [(ngModel)]="model.data.finishDate"
                        (valueChange)="shiftFinishDateChanged($event)"></wbo-date-edit-control>
                </fui-column>
                <fui-column>
                    <wbo-time-edit-control
                        formControlName="finishTime"
                        [(ngModel)]="model.data.finishTime"
                        (valueChange)="shiftFinishTimeChanged($event)"></wbo-time-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
        <fui-row [label]="'wbo.shift.edit.grid.breaks'">
            <wbo-edit-grid #breaksEditGridComponent [data]="model.data.breaks" [editable]="true"
                           [removable]="true" [entityPath]="'breaks'">
                <wbo-date-column field="startDate" [editable]="true"
                                 (valueChange)="breakStartDateChanged($event)"></wbo-date-column>
                <wbo-time-column field="startTime" [editable]="true"
                                 (valueChange)="breakStartTimeChanged($event)"></wbo-time-column>
                <wbo-date-column field="finishDate" [editable]="true"
                                 (valueChange)="breakFinishDateChanged($event)"></wbo-date-column>
                <wbo-time-column field="finishTime" [editable]="true"
                                 (valueChange)="breakFinishTimeChanged($event)"></wbo-time-column>
                <wbo-edit-grid-add-row>
                    <wbo-edit-grid-add-row-actions>
                        <wbo-edit-grid-add-row-new></wbo-edit-grid-add-row-new>
                    </wbo-edit-grid-add-row-actions>
                </wbo-edit-grid-add-row>
            </wbo-edit-grid>
        </fui-row>
        <fui-row>
            <fui-two-columns>
                <fui-column>
                    <wbo-text-edit-control formControlName="totalHours" [(ngModel)]="model.data.totalHours"
                                           [readonly]="true"></wbo-text-edit-control>
                </fui-column>
            </fui-two-columns>
        </fui-row>
    </fui-rows>
</wbo-edit-page>

